import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'translations';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';

function FreeDeliveryBatch({ openModal }) {
    return (
        <div className="grid--container">
            <div className="cms-placeholder cms-placeholder__section free-delivery-batch__wrapper">
                <div onClick={() => openModal({ layout: 'zip-form' })} className='free-delivery-batch'>
                    <div className='free-delivery-batch__text'>
                        { t('amigos.free-delivery') }
                    </div>
                </div>
            </div>
        </div>
    );
};

FreeDeliveryBatch.propTypes = {
    openModal: PropTypes.func.isRequired,
};



export default connect(
    null,
    reduxUtils.mapDispatchToProps({
        openModal: 'modal.open',
    }),
)(FreeDeliveryBatch);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/free-delivery-batch/index.js